<template>
  <div class="receiving-data">
    <div class="search">
      <el-form ref="searchForm" :model="searchForm" label-width="100px">
        <el-form-item label="货主：" prop="customerId" class="customer-form">
          <el-select 
            class="white"
            clearable
            v-model="searchForm.customerId"
            placeholder="请选择货主"
          >
            <el-option
              v-for="item in customerList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="入库时间：" prop="date">
          <el-date-picker
            v-model="searchForm.date"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-button class="btn-blue" @click="search">搜索</el-button>
        <el-button class="btn-white" @click="resetForm('searchForm')">清空</el-button>
      </el-form>
      <div class="operation-btn">
        <el-button
          class="btn-white download-content"
          icon="el-icon-download"
          @click="openExcel"
          >导入</el-button
        >
      </div>
    </div>
    <div class="table">
      <el-table ref="table" :data="tableData" style="width: 100%">
        <el-table-column
          v-for="(item, index) in tableTitleList"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          show-overflow-tooltip
          :min-width="item.width"
        ></el-table-column>
      </el-table>
      <div class="pagination">
        <pagination-tpl
          :total="total"
          :currentPage="currentPage"
          :pageSize="pageSize"
          @queryChange="queryChange"
        ></pagination-tpl>
      </div>
    </div>

    <!-- 订单导入 -->
    <el-dialog class="down-dialog" title="订单导入" top="20vh" :visible.sync="promptingDialog" width="420px" :before-close="closeOrderDown">
      <div class="border"></div>
      <div>
        <div>
          <i class="el-icon-warning"></i>
          <span class="sub-title introduce">功能介绍</span>
        </div>
        <p class="tips">从WMS出入库明细中导出类型为调拨入库、采购入库、其他入库的数据后导入系统</p>
      </div>
      <div class="down-tmp">
        <div class="sub-title">
          <span>下载导入模板</span>
          <span class="sub-tips">(点击下载)</span>
        </div>
        <el-button type="text" class="btn-text" @click="downTmp">收货数据导入模板.xlsx</el-button>
      </div>
      <div>
        <p class="sub-title">收货数据导入</p>
        <el-upload
          v-if="isUpload"
          v-loading.fullscreen.lock="loading3"
          element-loading-text="文件上传中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
          class="upload"
          ref="upload"
          action="#"
          :show-file-list="false"
          :auto-upload="true"
          :before-upload="uploadExcel"
        >
          <el-button slot="trigger" type="text" class="btn-text"
            >{{uploadTipsName}}</el-button
          >
        </el-upload>
        <div v-else class="upload-tips-container">
          <div class="upload-tips-name">
            {{uploadTipsName}}
            <i class="el-icon-error" @click="removeUploadOrder"></i>
          </div>
        </div>
      </div>
      <div class="dialog-footer">
        <el-button class="btn-white" @click="closeOrderDown"
          >取消</el-button
        >
        <el-button class="btn-blue" @click="confirmOrderDown"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PaginationTpl from "components/base/PaginationTpl";
import Logistics from "models/logistics";
const logistics = new Logistics();
import ReceivingData from "models/data-entry/receiving-data";
import { downLoadFile } from "common/js/util";
export default {
  components: {
    PaginationTpl
  },

  data() {
    return {
      total: 0,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      tableTitleList: [
        {label: '入库时间', prop: 'createTime', width: '150'},
        {label: '入库类型', prop: 'typeVal', width: ''},
        {label: '货主', prop: 'customerName', width: ''},
        {label: '入库数量', prop: 'nums', width: '120'},
      ],
      customerList: [],
      searchForm: {
        customerId: '',
        date: ''
      },
      typeObj: {
        1: '调拨入库',
        2: '采购入库',
        3: '其他入库'
      },
      loading3: false,
      promptingDialog: false,
      uploadTipsName: '点击导入',
      /* 订单导入的流 */
      formData: null,
      /* 是否导入 */
      isUpload: true,
    }
  },

  created() {
    this.initList()
    this.getCustomerList()
  },

  methods: {
    initList() {
      let pageNo = this.currentPage
      let customerId = this.searchForm.customerId
      let warehousingDate = this.searchForm.date
      let data = {
        pageNo,
        customerId,
        warehousingDate
      }
      ReceivingData.getReceivingDataList(data).then(res => {
        if (res.success) {
          let arr = []
          this.total = res.result.totalNum
          this.pageSize = res.result.pageSize
          res.result.items.map(i => {
            let obj = {}
            obj.id = i.id
            obj.customerName = i.customerName
            obj.createTime = i.warehousingDate
            obj.nums = i.inboundQuantity
            obj.type = i.inboundType
            obj.typeVal = this.typeObj[i.inboundType]
            arr.push(obj)
          })
          this.tableData = arr
        } else {
          this.$message.error(res.message)
        }
      })
    },

    /* 获取货主名称 */
    getCustomerList() {
      logistics.getCustomerData().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.ordersName;
            arr.push(obj);
          });
          this.customerList = arr;
        }
      });
    },

    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initList();
    },

    search() {
      this.currentPage = 1
      this.initList();
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    
    downTmp() {
      let url = 'https://xinge-kz.oss-cn-hangzhou.aliyuncs.com/oa/template/%E6%94%B6%E8%B4%A7%E6%95%B0%E6%8D%AE%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xls'
      downLoadFile('收货数据导入模板',url)
    },
    closeOrderDown() {
      this.removeUploadOrder()
      this.promptingDialog = false
    },
    confirmOrderDown() {
      if (this.isUpload) {
        return this.$message.error("请导入文件");
      }
      ReceivingData
        .postExcel(this.formData)
        .then(res => {
          if (res.success) {
            this.$message.success("导入成功");
            this.initList()
            this.closeOrderDown()
          } else {
            this.$confirm(res.message, "提示", {
              showCancelButton: false,
              confirmButtonText: "确定",
              type: "warning"
            }).then(() => {});
          }
        })
        .catch(res => {
          console.log(res);
          this.$message.error("导入失败");
        });
    },
    removeUploadOrder() {
      this.formData = null
      this.uploadTipsName = '点击导入'
      this.isUpload = true
    },
    //导入Excel表格
    uploadExcel(file) {
      var formData = new FormData();
      formData.append("file", file);
      this.formData = formData
      this.uploadTipsName = file.name
      this.isUpload = false
      return false;
    },
    openExcel() {
      this.promptingDialog = true
    }
  }
}
</script>

<style lang='scss'>
.receiving-data {
  flex: 1;
  background: #fff;
  border-radius: 4px;
  box-sizing: border-box;
  .search {
    background: #fff;
    border-radius: 8px;
    margin-bottom: 16px;
    padding: 0px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eee;
    .btn-blue,
    .btn-gray {
      margin-left: 16px;
    }
    .download-content {
      padding: 0px 14px;
    }
    .el-form {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      height: 72px;
      .el-form-item {
        margin-bottom: 0px;
      }
      .customer-form {
        .el-form-item__label {
          width: 50px!important;
        }
        .el-form-item__content {
          margin-left: 50px!important;
        }
      }
    }
  }
  .table {
    padding: 16px;
  }
  .pagination {
    display: flex;
    justify-content: flex-end;
  }
  .down-dialog {
    .down-tmp {
      margin-bottom: 8px;
    }
    .el-icon-warning {
      font-size: 16px;
      color: #F47A25;
      margin-right: 6px;
      vertical-align: middle;
      margin-bottom: 2px;
    }
    .sub-title {
      font-size: 14px;
      font-weight: 400;
      color: #333333;
    }
    .introduce {
      display: inline-block;
    }
    .tips {
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      margin: 11px 0px 21px 0px;
    }
    .upload-tips-container {
      position: relative;
      width: 180px;
      .upload-tips-name {
        height: 30px;
        line-height: 30px;
        margin: 12px 0px;
        color: #2E68EA;
        background: #EBEEF5;
        border-radius: 2px;
        padding-left: 7px;
        box-sizing: border-box;
        overflow : hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        .el-icon-error {
          position: absolute;
          top: -5px;
          right: -8px;
          color: #999999;
          cursor: pointer;
        }
      }
    }
    .sub-tips {
      color: #999999;
    }
    .dialog-footer {
      margin-top: 16px;
      border-top: 1px solid #f7f7f7;
      padding-top: 16px;
      display: flex;
      justify-content: center;
      .btn-white {
        margin-right: 20px;
      }
    }
  }
}
</style>
